import { useCallback, useEffect } from "react";
import { noticeInteraction } from "../services/monitoring";

export default function useInteractionMonitoring() {
  const handleClick = useCallback((e) => {
    const el = e.target.closest("a,button");
    if (el) {
      const interactionId = el.getAttribute("data-interaction-id");
      if (interactionId) {
        const params = {};
        el.attributes.forEach((attr) => {
          const prefix = "data-interaction-param-";
          if (attr.name.indexOf(prefix) === 0) {
            const paramName = attr.name.substr(prefix.length);
            params[paramName] = attr.value;
          }
        });
        noticeInteraction(interactionId, params);
      }
    }
  }, []);

  useEffect(() => {
    // useCapture to read attribute values before react updates them
    window.addEventListener("click", handleClick, true);
    return () => {
      window.removeEventListener("click", handleClick, true);
    };
  }, [handleClick]);
}
